import './App.less';

export const prefix = 'bm-app';

export { default } from './App';
